import { SegmentedControl } from '@radix-ui/themes';
import { t } from 'i18next';
import { IDeliveryProps } from 'interfaces/i-video-options';
import { DeliveryType } from 'lib_ts/enums/pitches.enums';

export const DeliveryControl = (props: IDeliveryProps) => {
  return (
    <SegmentedControl.Root
      value={props.delivery}
      onValueChange={(v) => {
        if (props.disabled) {
          props.onDisabled?.();
          return;
        }

        props.onChangeDelivery(v as DeliveryType);
      }}
      style={{ width: '100%' }}
      size="1"
    >
      <SegmentedControl.Item value={DeliveryType.Windup}>
        {t('constants.windup')}
      </SegmentedControl.Item>
      <SegmentedControl.Item value={DeliveryType.Stretch}>
        {t('constants.stretch')}
      </SegmentedControl.Item>
    </SegmentedControl.Root>
  );
};
